export default __webpack_public_path__ + "e38bcfa69288994aba31a3d6d3c41f78.svg";